import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useLocationSchema = () => {
  const { t } = useTranslation();
  const requiredError = t('errors.required') || '';

  return yup.object({
    name: yup.string().required(requiredError),
  });
};
